import { Injectable } from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular';
import { ColumnApi } from 'ag-grid-community';
import { AgGridLocaleIt } from 'src/domain/utils/gridLocales/AgGridLocaleIt';
import { BtnCellRendererRemoveComponent } from '../components/grid-addons/btn-cell-renderer-remove/btn-cell-renderer-remove.component';
import { BtnCellRendererComponent } from '../components/grid-addons/btn-cell-renderer/btn-cell-renderer.component';
import { ColorCellRendererComponent } from '../components/grid-addons/color-cell-renderer/color-cell-renderer.component';
import { ImageCellRendererComponent } from '../components/grid-addons/image-cell-renderer/image-cell-renderer.component';
import { CheckboxRenderer } from  'src/app/components/grid-addons/checkbox-renderer/checkbox-renderer.component';

@Injectable({
  providedIn: 'root'
})
export class GridService {
  gridColumnApi;
  frameworkComponents: any;

  localeText;

  defaultColDef = {
    width: 250,
    minWidth: 100,
    sortable: true,
    filter: true,
    resizable: true,
    enableRowGroup: false,
    wrapText: false,
    autoHeight: false,
    menuTabs: ['filterMenuTab', 'columnsMenuTab'],
  };

  autoGroupColumnDef = {
    minWidth: 200
  };

  constructor() {
    this.frameworkComponents = {
      btnCellRenderer: BtnCellRendererComponent,
      btnCellRendererRemove: BtnCellRendererRemoveComponent,
      colorCellRenderer: ColorCellRendererComponent,
      imageCellRenderer: ImageCellRendererComponent,
      checkboxRenderer: CheckboxRenderer
    }

    this.localeText = AgGridLocaleIt.AG_GRID_LOCALE_IT;    
  }

  public resizeAllColumns(grid: AgGridAngular) {
    // grid.columnApi.autoSizeAllColumns();
  }
  public autoSizeAll(gridColumnApi) {
    const allColumnIds = [];
    gridColumnApi.getAllColumns().forEach((column) => {
      allColumnIds.push(column.getId());
    });
  
    gridColumnApi.autoSizeColumns(allColumnIds, false);
  }
   
  public currencyFormatter(val) {
    if(!val){
      return '';
    }
    const formatter = new Intl.NumberFormat('it-IT', {
     // style: 'currency',
      // These options are needed to round to whole numbers if that's what you want.
      minimumFractionDigits: 2, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
      maximumFractionDigits: 2, // (causes 2500.99 to be printed as $2,501)
    });
    return '€ ' + formatter.format(val);
  }
  
  

}
